export const boxValues = [
    { value: 1000000, text: 'Unique and in demand events sold on our site', suffix: '+' },
    { value: 15, text: 'Pumped fans have found their event tickets through us', suffix: 'M+' },
    { value: 100, text: 'Memory-making tickets sold', suffix: 'M+' },
]
